import { Application } from "./Application.js";

const app = new Application();
app.init();

// 전역에서 접근 가능하도록 설정
window.app = app;
